import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useConsultorios } from './hooks/useConsultorios';

import { Error, Forbidden, Loader, PrimaryButton } from '../../components';
import { Consultorio } from './components/Consultorio';
import { ConsultorioCreate } from './components/ConsultorioCreate';

import styles from './Consultorios.module.css';
import { roles } from '../../types/types';

export const Consultorios = () => {

  const { user } = useSelector(state => state.auth);

  const { consultoriosQuery: { isLoading, isError, data: consultorios } } = useConsultorios();

  const [consultorioCreateStatus, setConsultorioCreateStatus] = useState(false);

  const handleCrearConsultorio = () => {
    setConsultorioCreateStatus(true);
  }

  const handleCancelarCrearConsultorio = () => {
    setConsultorioCreateStatus(false);
  }

  return (user.rol === roles.MEDICO) ? (
    <>
      <div className={styles.header}>Consultorios</div>
      {(isLoading)
        ? <Loader />
        : <>
            {(isError)
            ? <Error />
            : <>
              {consultorios.map(consultorio => <Consultorio key={consultorio._id} consultorio={consultorio} />)}
              {(consultorioCreateStatus)
              ? <>
                <ConsultorioCreate handleCancelarCrearConsultorio={handleCancelarCrearConsultorio} />
              </>
              : <>
                <div className='d-flex justify-content-end'>
                  <PrimaryButton
                    icon="Plus"
                    inverse={true}
                    marginTop={false}
                    onClick={handleCrearConsultorio}
                    text="Agregar Consultorio"
                    type="button"
                  />
                </div>
              </>
              }
            </>
            }
        </>
      }
    </>
  ) : <div className='mt-3'><Forbidden /></div>
}
